import { APP_CONFIG } from './config.js';
import { appState } from './state.js';

export function isNodeEnvironment() {
  return typeof process !== 'undefined' && process.versions && process.versions.node;
}

export async function myFetchJsonContent(folderPath) {
  const filePath = isNodeEnvironment()
    ? `${process.cwd()}/src/${folderPath}`
    : `${appState.BASE_URL}/${folderPath}`;

  try {
    if (isNodeEnvironment()) {
      const fs = await import('fs/promises');
      console.log('🔄 Attempting to load from file system:', filePath);
      let fileContent = await fs.readFile(filePath, 'utf8');

      // Strip BOM if present
      if (fileContent.charCodeAt(0) === 0xfeff) {
        console.warn('⚠️ BOM detected, removing...');
        fileContent = fileContent.slice(1);
      }

      return JSON.parse(fileContent); // Parse JSON directly
    } else {
      console.log('🌐 Attempting to load from URL:', filePath);
      const response = await fetch(filePath);
      if (!response.ok) throw new Error(`Failed to load content from: ${filePath}`);
      let jsonData = await response.text();

      // Strip BOM if present
      if (jsonData.charCodeAt(0) === 0xfeff) {
        console.warn('⚠️ BOM detected in fetched content, removing...');
        jsonData = jsonData.slice(1);
      }

      return JSON.parse(jsonData); // Parse JSON directly from the response
    }
  } catch (error) {
    console.error('❌ Error fetching content from:', filePath, error.message);
    return {}; // Return an empty object on error
  }
}

export async function myFetchJsonContentFromBuildData(folderPath) {
  const filePath = isNodeEnvironment()
    ? `${process.cwd()}/build_data/${folderPath}`
    : `${appState.BASE_URL}/${folderPath}`;

  try {
    if (isNodeEnvironment()) {
      const fs = await import('fs/promises');
      console.log('🔄 Attempting to load from file system:', filePath);
      let fileContent = await fs.readFile(filePath, 'utf8');

      // Strip BOM if present
      if (fileContent.charCodeAt(0) === 0xfeff) {
        console.warn('⚠️ BOM detected, removing...');
        fileContent = fileContent.slice(1);
      }

      return JSON.parse(fileContent); // Parse JSON directly
    } else {
      console.log('🌐 Attempting to load from URL:', filePath);
      const response = await fetch(filePath);
      if (!response.ok) throw new Error(`Failed to load content from: ${filePath}`);
      let jsonData = await response.text();

      // Strip BOM if present
      if (jsonData.charCodeAt(0) === 0xfeff) {
        console.warn('⚠️ BOM detected in fetched content, removing...');
        jsonData = jsonData.slice(1);
      }

      return JSON.parse(jsonData); // Parse JSON directly from the response
    }
  } catch (error) {
    console.error('❌ Error fetching content from:', filePath, error.message);
    return {}; // Return an empty object on error
  }
}
